/**
 * Function that returns the oldest removable alert based on the created_time
 * @param {Object} alerts - alerts in the queue. excluding removed alerts
 * @param {String} selectedAlertID - the selected alert
 */
const getOldestRemovableAlert = (alerts, selectedAlertID = null) => {
  const sortedQueue = Object.entries(alerts).sort(
    (a, b) => b[1].created_time - a[1].created_time,
  );

  const oldestAlertID = sortedQueue[Object.keys(sortedQueue).length - 1][0];
  const secondOldestAlertID =
    sortedQueue[Object.keys(sortedQueue).length - 2][0];
  return oldestAlertID !== selectedAlertID
    ? oldestAlertID
    : secondOldestAlertID;
};

export default getOldestRemovableAlert;
